// extracted by mini-css-extract-plugin
export default {"button":"_1xEhS4ZNNd9qAtQ2FNxUrY","isOpened":"_2lnh-GlZfziZ9IGvrK2Mvx"};